import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export const FrameworkCard = ({ framework }) => {
  return (
    <Link
      to={`/work/${framework.slug}`}
      className="group block"
      data-testid={`framework-card-${framework.slug}`}
    >
      <div className="h-full rounded-xl bg-[hsl(var(--card))] border border-[rgba(201,168,76,0.25)] shadow-[0_18px_60px_rgba(0,0,0,0.45)] p-6 sm:p-8 transition-all duration-300 hover:border-[rgba(201,168,76,0.45)] hover:bg-[rgba(27,77,68,0.18)]">
        {/* Tags */}
        <div className="flex flex-wrap gap-2 mb-4">
          {framework.tags?.slice(0, 3).map(tag => (
            <Badge
              key={tag}
              variant="outline"
              className="font-['Inter'] text-[10px] font-medium uppercase tracking-[0.14em] border-[rgba(168,181,178,0.2)] text-[hsl(var(--silver))] bg-transparent px-2.5 py-0.5"
            >
              {tag}
            </Badge>
          ))}
        </div>

        {/* Title */}
        <h3 className="font-['Cormorant_Garamond'] text-xl sm:text-2xl font-semibold italic text-[hsl(var(--foreground))] mb-2 leading-[1.2]">
          {framework.name}
        </h3>

        {/* Tagline */}
        {framework.tagline && (
          <p className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--gold))] mb-4">
            {framework.tagline}
          </p>
        )}

        {/* Summary */}
        <p className="font-['Inter'] text-sm leading-[1.7] text-[hsl(var(--muted-foreground))] mb-6 line-clamp-3">
          {framework.summary}
        </p>

        {/* Footer */}
        <div className="flex items-center justify-between">
          {framework.reading_time && (
            <span className="font-['Inter'] text-xs text-[hsl(var(--silver))]">
              {framework.reading_time} min read
            </span>
          )}
          <span className="inline-flex items-center gap-1.5 font-['Inter'] text-xs font-medium text-[hsl(var(--gold))] group-hover:gap-2.5 transition-all duration-300">
            Open
            <ArrowRight className="h-3 w-3" />
          </span>
        </div>
      </div>
    </Link>
  );
};
